export const popupTopCenterStyles = {
  content: {
    top: '30%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    //marginRight: '-50%',
    //marginBottom: '-100%',
    transform: 'translate(-50%, -50%)',
    zIndex: '30',
  },
  overlay: {
    backgroundColor: 'rgba(0,0,0,0.7)',
    zIndex: '100',
  },
}

export const popupMiddleCenterStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    //marginRight: '-50%',
    //marginBottom: '-100%',
    transform: 'translate(-50%, -50%)',
    zIndex: '30',
  },
  overlay: {
    backgroundColor: 'rgba(0,0,0,0.7)',
    zIndex: '100',
  },
}
